/* Phone menu: accordion rows become pages.

   Tapping WOMEN on Saint Laurent's phone menu turns the page - the other rows
   go, the heading becomes a back arrow, and WOMEN's contents fill the pane.
   The theme ships the same menu as a details/summary accordion that expands in
   place. This script adds the page behaviour on top of that markup without
   replacing it, which matters: the markup stays the theme's, so the menu still
   works if this file fails to load, and no Liquid had to be forked.

   HOW IT HOOKS IN. Not by intercepting clicks on the summary - the theme has
   its own handlers there, and fighting them is how you get a menu that opens
   twice or not at all. Instead it listens for the `toggle` event that <details>
   fires whenever it opens or closes, whatever did the opening: a tap, the
   theme's own code, a keyboard. `toggle` does not bubble, so the listener is
   registered in the capture phase, where non-bubbling events still pass through
   document on their way down.

   The hiding is CSS's job (see dico-frosted-nav.css). All this does is mark
   which row is open and put a back row at the top of its contents.
*/
(function () {
    'use strict';

    var PHONE = 777;
    var scope = '#mobmenu';

    function phone() {
        return window.innerWidth <= PHONE;
    }

    function inMenu(el) {
        return el && el.closest && el.closest(scope + ' .menus');
    }

    /* The pane a row opens into. */
    function pane(details) {
        return details.querySelector(':scope > details-menu');
    }

    /* Where the back row goes: the opened level's own <ul>, so the back row is
       an <li> among the links it heads. That way it picks up the list's
       indentation and type from the theme instead of being positioned by hand
       against measurements that would drift the moment the theme changed. */
    function paneTop(details) {
        var p = pane(details);
        if (!p) { return null; }
        return p.querySelector(':scope > .mob-scroller > ul')
            || p.querySelector('ul')
            || p.querySelector(':scope > .mob-scroller')
            || p;
    }

    function label(details) {
        var s = details.querySelector(':scope > summary');
        if (!s) { return ''; }
        return (s.getAttribute('data-name') || s.textContent || '').trim();
    }

    function makeBack(text, asListItem) {
        var b = document.createElement('button');
        b.type = 'button';
        /* The theme's own link classes, so the row matches the links below it
           without this file restating their typography. */
        b.className = 'dnav-back button is-blank text-normal';
        b.setAttribute('data-dnav-back', '');
        b.innerHTML = '<svg viewBox="0 0 7 12" fill="none" aria-hidden="true" focusable="false">'
                    + '<path d="M6 1 1 6l5 5" stroke="currentColor" stroke-width="1.4"/></svg>'
                    + '<span></span>';
        b.querySelector('span').textContent = text;

        if (!asListItem) {
            b.setAttribute('data-dnav-back-row', '');
            return b;
        }
        var li = document.createElement('li');
        li.setAttribute('data-dnav-back-row', '');
        li.appendChild(b);
        return li;
    }

    /* The pane scrolls, or an ancestor of it does. Sending the new page to the
       top is the difference between a page turn and landing halfway down a
       list you have not seen yet. */
    function toTop(details) {
        var el = details;
        while (el && el !== document.body) {
            if (el.scrollHeight > el.clientHeight + 4) { el.scrollTop = 0; }
            el = el.parentElement;
        }
        var sheet = document.querySelector(scope + ' .mobnav');
        if (sheet) { sheet.scrollTop = 0; }
    }

    function opened(details) {
        var li = details.closest('li');
        if (li) { li.classList.add('dnav-open'); }

        var top = paneTop(details);
        if (top && !top.querySelector(':scope > [data-dnav-back-row]')) {
            top.insertBefore(makeBack(label(details), top.tagName === 'UL'), top.firstChild);
        }
        toTop(details);
    }

    function closed(details) {
        var li = details.closest('li');
        if (li) { li.classList.remove('dnav-open'); }
    }

    /* Catch the open/close however it happened. Capture phase, because `toggle`
       does not bubble. */
    document.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d || d.tagName !== 'DETAILS' || !inMenu(d)) { return; }
        if (!phone()) { return; }
        if (d.open) { opened(d); } else { closed(d); }
    }, true);

    /* Back: close the row this button belongs to, which the toggle handler then
       tidies up after. */
    document.addEventListener('click', function (e) {
        var back = e.target.closest('[data-dnav-back]');
        if (!back) { return; }
        e.preventDefault();
        e.stopPropagation();
        var d = back.closest('details');
        if (d) {
            d.open = false;
            var s = d.querySelector(':scope > summary');
            if (s) { s.focus({ preventScroll: true }); }
        }
    });

    /* Reopening the menu should start at the top level rather than wherever the
       customer left off, and crossing to desktop width should leave no drilled
       state behind for the accordion to inherit. */
    function reset() {
        var open = document.querySelectorAll(scope + ' .menus li.dnav-open');
        for (var i = 0; i < open.length; i++) {
            open[i].classList.remove('dnav-open');
            var d = open[i].querySelector(':scope > details');
            if (d) { d.open = false; }
        }
    }

    var panel = document.getElementById('mobmenu');
    if (panel) {
        /* Popover close fires `toggle` on the panel itself; it is not a
           <details>, so the handler above ignores it and this catches it. */
        panel.addEventListener('toggle', function (e) {
            if (e.newState === 'closed') { reset(); }
        });
        panel.addEventListener('close', reset);
    }

    var wide = !phone();
    window.addEventListener('resize', function () {
        var nowWide = !phone();
        if (nowWide !== wide) { wide = nowWide; reset(); }
    });
}());
